import React from 'react';
import './ContactIntro.css';
import socialNetwork from '../../utils/socialNetworkingLinks';

export default class Contact extends React.Component {
  handleMouseMove = (event) => {
    this.eyeRotateAnimation(event);
  }

  eyeRotateAnimation(event) {
    const eyes = document.querySelectorAll(".contact .intro .eye")
    const clientX = event.clientX;
    const clientY = event.clientY;
    const eyeLeftX = eyes[0].getBoundingClientRect().left;
    const eyeLeftY = eyes[0].getBoundingClientRect().top;
    const diffX = eyeLeftX - clientX;
    const diffY = eyeLeftY - clientY;
    const rotate = (-Math.atan2(diffX,diffY) * 180/Math.PI)+90;
    
    eyes[0].querySelector("span").style.transform=`rotate(${rotate}deg)`;
    eyes[1].querySelector("span").style.transform=`rotate(${rotate}deg)`
  }

  render() {
    return (
      <div className="intro" onMouseMove={(e) => this.handleMouseMove(e)}>
        <h1>Get in touch to discuss your needs today.</h1>

        <div className="contact-contactInfo">
          <div>Email: <a href={socialNetwork.email} rel="noreferrer" >tielinli@yahoo.com</a></div>

          <div>Github: <a href={socialNetwork.gitHub} target="_blank" rel="noreferrer" >ltlkong</a></div>

          <div>LeetCode: <a href={socialNetwork.leetcode} target="_blank" rel="noreferrer" >ltlkong</a></div>

          <div>LinkedIn: <a href={socialNetwork.linkedIn} target="_blank" rel="noreferrer" >Tielin Li</a></div> 

          <div>Ins: <a href={socialNetwork.instagram} target="_blank" rel="noreferrer" >tielin_li</a></div>

          <div>WeChat: <a>ltlT_Twechat</a></div>
        </div>

        <div className="contact-fun">
          <div className="eye-left eye">
            <span></span>
          </div>

          <div className="eye-right eye">
            <span></span>
          </div>

          <div></div>

          <div className="phrase">
            I am currently looking for a full-stack developer job!!!
          </div>
        </div>

        <div className="border"></div>
      </div>
    )
  }
}